export default function num2wordsFa(number) {
    const yekan = ["", "یک", "دو", "سه", "چهار", "پنج", "شش", "هفت", "هشت", "نه"];
    const dahgan = ["", "ده", "بیست", "سی", "چهل", "پنجاه", "شصت", "هفتاد", "هشتاد", "نود"];
    const sadgan = ["", "یکصد", "دویست", "سیصد", "چهارصد", "پانصد", "ششصد", "هفتصد", "هشتصد", "نهصد"];
    const dah_2 = ["ده", "یازده", "دوازده", "سیزده", "چهارده", "پانزده", "شانزده", "هفده", "هجده", "نوزده"];
    const units = ["", "هزار", "میلیون", "میلیارد", "تریلیون"];

    function threeDigitToWord(n) {
        let parts = [];
        const d3 = Math.floor(n / 100);
        const d2 = Math.floor((n % 100) / 10);
        const d1 = n % 10;

        if (d3) parts.push(sadgan[d3]);

        if (d2 > 1) {
            parts.push(dahgan[d2]);
            if (d1) parts.push(yekan[d1]);
        } else if (d2 === 1) {
            parts.push(dah_2[d1]);
        } else if (d1) {
            parts.push(yekan[d1]);
        }

        return parts.join(" و ");
    }

    if (number === 0) return "صفر";

    let parts = [];
    let i = 0;
    while (number > 0) {
        let n = number % 1000;
        number = Math.floor(number / 1000);
        if (n !== 0) {
            let word = threeDigitToWord(n);
            if (units[i]) word += " " + units[i];
            parts.push(word);
        }
        i++;
    }

    return parts.reverse().join(" و ");
}